import React, { useEffect, useState } from "react";
import QRCodeSection from "../components/UserDashboard/QRCodeSection";
import MenuUploadDownload from "../components/UserDashboard/MenuUploadDownload";
import UserBG from "../assets/loginBG.jpg";
import { useAuth } from "../state/AuthContext";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import ChangePasswordModal from "../components/UserDashboard/ChangePassword";
import EditWhatsappModal from "../components/UserDashboard/EditWhatsappModal";
import { FaBars, FaTimes, FaKey, FaSignOutAlt, FaWhatsapp, FaShoppingCart } from 'react-icons/fa'; // Icons for hamburger and buttons
import Footer from "../components/Consumer/Footer";
import { toast, ToastContainer } from "react-toastify";
import { downloadMenu, handleUpload } from "../utils/DownloadMenu";
import { FaUser } from "react-icons/fa";
//@ts-ignore
import CryptoJS from 'crypto-js';

const UserDashboard = () => {
  const { logout, user } = useAuth();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState();
  const [error, setError] = useState();
  const [menuDetails, setMenuDetails] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [decryptedPassword, setDecryptedPassword] = useState('');
  //console.log("my user---======111", user, 'password', decryptedPassword);
  const handleLogout = () => {
    logout(navigate);
  };

  const handleOrders = () => {
    navigate('/orders', { state: { user: user } });
  };
  //console.log("diffffffff",user?.email=== user, 'sdcsdcsdc', user, 'sdcsdcsdc', user?.email)
  useEffect(() => {
    if (user?.email || user) {
      fetchDashboardDetails();
    }
  }, [user]);

  //console.log("suususuus", userDetails, "menehueuue", menuDetails);

  const generateId = () => {
    // const id = formData?.businessName
    //   .toLowerCase()
    //   .replace(/\s+/g, "-")
    //   .replace(/[^a-z0-9-]/g, "");
    // console.log("id", id);
    // setFormData((prev) => ({ ...prev, businessName: id }));
  };

     const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
  
    const decryptPassword = (encryptedPassword) => {
      const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
      setDecryptedPassword(bytes.toString(CryptoJS.enc.Utf8));
    };
  

  const fetchDashboardDetails = async () => {
    try {
      if(!menuDetails){
      const userDocRef = doc(db, "userDetails", (user?.email || user));
      const userSnap = await getDoc(userDocRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        setUserDetails(userData);
        // decrypt password
        decryptPassword(userData?.password);

        if (userData?.businessName) {
          const menuRef = doc(
            db,
            "menus",
            userData?.businessName
            //These changes are done on 03/05/2025 by Arvind - To allow download of the english menu
              .toLowerCase()
              .replace(/\s+/g, "-")
              .replace(/[^a-z0-9-]/g, "")
             
          );
         
         // console.log(
         //   "menuuuu",
        //    menuRef,
         //   "idididiidd",
         //   userData?.businessName
         //     .toLowerCase()
         //     .replace(/\s+/g, "-")
         //     .replace(/[^a-z0-9-]/g, "")
         // );
          const menuSnap = await getDoc(menuRef);

          if (menuSnap.exists()) {
            setMenuDetails(menuSnap.data());
          } else {
            setError("Menu details not found.");
          }
        }
      } else {
        setError("User not found.");
      }
    }else return
    } catch (err) {
      //console.error("Error fetching data:", err);
      setError("Failed to fetch details.");
    } finally {
      setLoading(false);
    }
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onDownloadEnglishMenu = () => {
    let hasDownload = downloadMenu(menuDetails?.englishMenu)   
    if(hasDownload === -1){
      toast.info("English Menu is not available");
    }else if(hasDownload === 1){
      toast.success("Menu Downloaded Successfully")
      return;
    }else{
      toast.error("Something went wrong, please try again later!")
    }
  }
  const onDownloadHindiMenu = () => {
    let hasDownload = downloadMenu(menuDetails?.hindiMenu)
    if(hasDownload === -1){
      toast.info("Indian Menu is not available");
    }else if(hasDownload === 1){
      toast.success("Menu Downloaded Successfully")
    }else{
      toast.error("Something went wrong, please try again later!")
    }
  }
  const onUploadEnglishMenu = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      console.log("Selected English Menu File:", file);
    }
    handleUpload(file, userDetails?.businessName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, ""), 'englishMenu')

  }
  const onUploadHindiMenu = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      //console.log("Selected Hindi Menu File:", file);
    }
    handleUpload(file, userDetails?.businessName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, ""), 'hindiMenu')
  }

  return (
    <div className="min-h-screen relative overflow-hidden">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      {/* Background Image */}
      <img
        className="absolute inset-0 z-0 object-cover w-full h-full opacity-10"
        src={UserBG}
        alt="Dashboard Background"
      />

      {/* Content */}
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto p-6">
         
        <div className=" p-2">
  <div className="flex items-center justify-between md:justify-start md:gap-6">
    {/* Toggle Button (Mobile only) */}
    <button
      onClick={toggleMenu}
      className="md:hidden text-gray-800 mr-4"
    >
      {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
    </button>

    {/* Logo and Heading */}
    <div className="flex items-center gap-3">
      {/* <img src={userDetails?.logo} className="w-14 h-14 rounded-full"/> */}
      <FaUser size={25} className="text-[#6cbb23] hidden md:block" />
      <h1 className="text-2xl md:text-xl text-gray-800">
      <strong className="text-[#6cbb23]"> {userDetails?.businessName} </strong>
      </h1>
    </div>

    {/* Buttons (Desktop only) */}
    <div className="hidden md:flex items-center gap-3 ml-auto">
  <button
    onClick={() => setIsModalOpen1(true)}
    className="bg-[#6cbb23] text-white px-4 py-1.5 rounded-md hover:bg-green-700 transition-all duration-300 text-sm flex items-center gap-1.5 shadow-sm"
  >
    <FaWhatsapp className="text-base" /> Update WhatsApp
  </button>

  <button
    onClick={() => setIsModalOpen(true)}
    className="bg-[#6cbb23] text-white px-4 py-1.5 rounded-md hover:bg-green-700 transition-all duration-300 text-sm flex items-center gap-1.5 shadow-sm"
  >
    <FaKey className="text-base" /> Change Password
  </button>

  <button
    onClick={handleOrders}
    className="bg-[#6cbb23] hover:bg-green-700 text-white px-4 py-1.5 rounded-md text-sm flex items-center gap-1.5 shadow-sm"
  >
    <FaShoppingCart className="text-base" /> Live Orders
  </button>

  <button
    onClick={handleLogout}
    className="bg-red-600 text-white px-4 py-1.5 rounded-md text-sm flex items-center gap-1.5 shadow-sm"
    title="Logout"
  >
    <FaSignOutAlt className="text-base" /> Logout
  </button>
</div>

  </div>

  {/* Buttons (Mobile View when Toggled) */}
{isMenuOpen && (
  <div className="flex flex-col mt-4 gap-3 md:hidden">
    <button
      onClick={() => setIsModalOpen1(true)}
      className="bg-[#6cbb23] text-white px-6 py-2 rounded-lg hover:bg-[#075E54] transition-all duration-300 text-sm flex items-center justify-center gap-2 shadow-md"
    >
      <FaWhatsapp /> Update WhatsApp
    </button>
    <button
      onClick={() => setIsModalOpen(true)}
      className="bg-[#6cbb23] text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-all duration-300 text-sm flex items-center justify-center gap-2 shadow-md"
    >
      <FaKey /> Change Password
    </button>
    <button
    onClick={handleOrders}
    className="bg-[#6cbb23] text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-all duration-300 text-sm flex items-center justify-center gap-2 shadow-md"
  >
    <FaShoppingCart className="text-base" /> Live Orders
  </button>
    <button
      onClick={handleLogout}
      className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-all duration-300 text-sm flex items-center justify-center gap-2 shadow-md"
    >
      <FaSignOutAlt /> Logout
    </button>
  </div>
  )}
</div>

          {/*  */}

          {/* Welcome Section */}
          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Analyze Your Business
            </h2>
            <p className="text-gray-600">
              Track your menu scans, payments, and manage your menus
              effortlessly.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
            {/* Total Menu Scans Card */}
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 h-full flex flex-col justify-between">
              <h3 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                Total Menu Views
              </h3>
              <p className="text-2xl font-semibold text-blue-600 mt-1">
                {userDetails?.menuShown ?? "-"}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Total number of times your menu has been viewed.
              </p>
            </div>

            {/* Last Payment Date Card */}
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 h-full flex flex-col justify-between">
              <h3 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                Last Payment Date
              </h3>
              <p className="text-xl font-semibold text-blue-600 mt-1">
                {userDetails?.lastPaymentDate
                  ? new Intl.DateTimeFormat("en-GB").format(
                     new Date(userDetails.lastPaymentDate)
                    )
                  : "-"}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Date of your most recent payment.
              </p>
            </div>

            {/* Last Payment Amount Card */}
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 h-full flex flex-col justify-between">
              <h3 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                Last Payment Amount
              </h3>
              <p className="text-xl font-semibold text-blue-600 mt-1">
                {userDetails?.lastPaymentAmount
                  ? '₹' + new Intl.NumberFormat("en-US").format(
                      userDetails.lastPaymentAmount
                    )
                  : "-"}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Amount of your most recent payment.
              </p>
            </div>

            {/* Next Payment Date Card */}
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 h-full flex flex-col justify-between">
              <h3 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                Next Payment Date
              </h3>
              <p className="text-xl font-semibold text-blue-600 mt-1">
                {userDetails?.nextPaymentDate
                  ? new Intl.DateTimeFormat("en-GB").format(
                      new Date(userDetails.nextPaymentDate)
                    )
                  : "-"}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Date of your Upcoming payment.
              </p>
            </div>

            {/* Next Payment Amount Card */}
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 border border-white/20 h-full flex flex-col justify-between">
              <h3 className="text-lg font-bold text-gray-800 whitespace-nowrap">
                Next Payment Amount
              </h3>
              <p className="text-xl font-semibold text-blue-600 mt-1">
                {userDetails?.nextPaymentAmount
                  ? '₹' + new Intl.NumberFormat("en-US").format(
                      userDetails.nextPaymentAmount
                    )
                  : "-"}
              </p>
              <p className="text-sm text-gray-600 mt-2">
                Amount of your upcoming payment.
              </p>
            </div>
          </div>

          {/* QR Code and Menu Upload/Download Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <MenuUploadDownload 
              onDownloadEnglishMenu={onDownloadEnglishMenu}
              onDownloadHindiMenu={onDownloadHindiMenu}
              onUploadEnglishMenu={onUploadEnglishMenu}
              onUploadHindiMenu={onUploadHindiMenu}
              />
            </div>
            <div>
              <QRCodeSection />
            </div>
          </div>
        </div>
      </div>
      <ChangePasswordModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} password={decryptedPassword} email={userDetails?.email}/>
      <EditWhatsappModal isOpen={isModalOpen1} onClose={() => setIsModalOpen1(false)} email={userDetails?.email}/>

      <Footer />
    </div>
  );
};

export default UserDashboard;
